<!--  -->
<template>
  <div class="">
    <div class="Receaddress js_netsilver">
      <h4>
        发票申请：
        <select class="js_choice" id="invoice_info" v-model="invoiceCategory">
          <option value="0">不开发票</option>
          <option value="3">个人(电子)</option>
          <option value="2">企业/机构</option>
        </select>
      </h4>
      <div class="js_personal ordinaryinvoice rechargemoney css_spanwidth" :style="personalStyle">
        <p>
          <span>发票抬头：</span>
          <input type="text" id="indivRise" value="个人" readonly="true" />

          <b class="prompt" id="personInvoiceTitle"></b>
        </p>
      </div>
      <div class="js_enterprise rechargemoney css_spanwidth" :style="companyStyle">
        <p id="radioType">
          <span><i class="colorred">*</i>发票类型：</span>
          <label><input type="radio" name="invoicetype" value="1_0" v-model="invoiceTypeMode" /><b>普通发票(电子)</b></label>
          <label><input type="radio" name="invoicetype" value="1_1" v-model="invoiceTypeMode" /><b>普通发票(纸质)</b></label>
          <label><input type="radio" name="invoicetype" value="2_1" v-model="invoiceTypeMode" /><b>专用发票(纸质)</b></label>
        </p>
        <div class="ordinaryinvoice">
          <p>
            <span><i class="colorred">*</i>发票抬头：</span>
            <input type="text" id="title" @blur="validateInput('title', '请输入发票抬头信息!')" @focus="focusTips('title', '单位发票抬头全称')" v-model="invoiceData.title" />
            <b id="icon_title"></b><b class="prompt" ref="msgtitle">请输入发票抬头信息!</b>
          </p>
          <p>
            <span><i class="colorred">*</i>纳税人识别号：</span>
            <input
              type="text"
              id="dutyparagraph"
              @blur="validateInput('dutyparagraph', '请填写纳税人识别号！')"
              @focus="focusTips('dutyparagraph', '纳税人识别号/统一社会信用代码/税号')"
              v-model="invoiceData.dutyparagraph"
            />
            <b id="icon_dutyParagaph"></b><b class="prompt" ref="msgdutyparagraph">纳税人识别号/统一社会信用代码/税号</b>
          </p>
        </div>
        <div class="specialinvoice">
          <p>
            <span><i class="colorred" ref="special1" style="display: none">*</i>开户银行：</span>
            <input type="text" id="openBank" v-model="invoiceData.openBank" @blur="validateInput('openBank', '请填写开户行信息！')" @focus="focusTips('openBank', '单位开户银行全称')" />
            <b id="icon_openBank"></b><b class="prompt" ref="msgopenBank">请填写开户行信息！</b>
          </p>
          <p>
            <span><i class="colorred" ref="special2" style="display: none">*</i>银行账号：</span>
            <input type="text" id="bankAccount" @blur="validateInput('bankAccount', '	请填写开户银行账号!')" @focus="focusTips('bankAccount', '开户银行账号')" v-model="invoiceData.bankAccount" />
            <b id="icon_bankAccount"></b><b class="prompt" ref="msgbankAccount"> 请填写开户银行账号!</b>
          </p>
          <p>
            <span><i class="colorred" ref="special3" style="display: none">*</i>地址：</span>
            <input
              type="text"
              id="invoiceAddress"
              @blur="validateInput('invoiceAddress', '请填写地址信息！')"
              @focus="focusTips('invoiceAddress', '请填写地址信息！')"
              v-model="invoiceData.invoiceAddress"
            />
            <b id="icon_invoiceAddress"></b><b class="prompt" ref="msginvoiceAddress">请填写地址信息！</b>
          </p>
          <p>
            <span><i class="colorred" ref="special4" style="display: none">*</i>电话：</span>
            <input type="text" id="invoicePhone" @blur="validateInput('invoicePhone', '请填写电话信息！')" @focus="focusTips('invoicePhone', '请填写电话信息！')" v-model="invoiceData.invoicePhone" />
            <b id="icon_invoicePhone"></b><b class="prompt" ref="msginvoicePhone">请填写电话信息！</b>
          </p>
        </div>
      </div>
      <div class="js_invoiceInformation rechargemoney css_spanwidth css_invoiceInformation" :style="perandcomStyle">
        <p>
          <span><i class="colorred">*</i>发票邮寄地址：</span>
          <input type="text" id="mailedAddress" v-model="invoiceData.mailedAddress" @blur="validateInput('mailedAddress')" @focus="focusTips('mailedAddress')" />
          <b id="icon_invoiceMailAddress"></b><b class="prompt" ref="msgmailedAddress">请填写发票邮寄地址！</b>
        </p>
        <p>
          <span><i class="colorred">*</i>发票邮寄电话：</span>
          <input type="text" id="mailedPhone" v-model="invoiceData.mailedPhone" @blur="validateInput('mailedPhone')" @focus="focusTips('mailedPhone')" />
          <b id="icon_invoiceMailingTel"></b><b class="prompt" ref="msgmailedPhone">请填写正确的电话信息！</b>
        </p>
        <p>
          <span><i class="colorred">*</i>邮编：</span>
          <input type="text" id="mailedPostcode" v-model="invoiceData.mailedPostcode" @blur="validateInput('mailedPostcode')" @focus="focusTips('mailedPostcode')" />
          <b id="icon_invoiceZipCode"></b><b class="prompt" ref="msgmailedPostcode">请填写邮政编码信息！</b>
        </p>
      </div>
      <div class="js_invoiceInformation rechargemoney css_spanwidth css_invoiceInformation" :style="perandcomStyle_elec">
        <p>
          <span><i class="colorred">*</i>发票接收邮箱：</span>
          <input type="text" maxlength="50" id="receiveEmail" v-model="invoiceData.invoiceReceiveEmail" @blur="validateInput('invoiceReceiveEmail')" @focus="focusTips('invoiceReceiveEmail')" />
          <b id="icon_invoiceReceiveEmail"></b><b class="prompt" ref="msginvoiceReceiveEmail">请填写发票接收邮箱！</b>
        </p>
        <p>
          <span><i class="colorred"></i>备用邮箱：</span>
          <input type="text" maxlength="50" id="receiveBackEmail" v-model="invoiceData.invoiceReceiveBackEmail" @blur="validateInput('invoiceReceiveBackEmail')" />
          <b id="icon_invoiceReceiveBackEmail"></b><b class="prompt" ref="msginvoiceReceiveBackEmail">请填写正确的备用邮箱！</b>
        </p>
        <p>
          <span><i class="colorred">*</i>发票接收手机：</span>
          <input type="text" maxlength="11" id="receivePhone" v-model="invoiceData.invoiceReceivePhone" @blur="validateInput('invoiceReceivePhone')" @focus="focusTips('invoiceReceivePhone')" />
          <b id="icon_invoiceReceivePhone"></b><b class="prompt" ref="msginvoiceReceivePhone">请填发票接收手机！</b>
        </p>
      </div>
      <div class="js_invoiceInformation rechargemoney css_spanwidth css_invoiceInformation" v-show="nameShow">
        <p>
          <span><i class="colorred">*</i>联系人：</span>
          <input type="text" id="mailedName" v-model="invoiceData.mailedName" @blur="validateInput('mailedName')" @focus="focusTips('mailedName')" />
          <b id="icon_invoiceContact"></b><b class="prompt" ref="msgmailedName">请填写联系人姓名！</b>
        </p>
      </div>
    </div>
    <!-- 发票获取方式 -->
    <div class="Receaddress" id="invoice_method_info_box" :style="perandcomStyle">
      <h4>
        发票获取方式：
        <select name="mailedType" class="" id="mailedType" v-model="invoiceData.mailedType">
          <option value="邮政挂号">邮政挂号(免费)</option>
          <option value="顺丰到付">顺丰到付</option>
          <option value="自取">自取</option>
        </select>
      </h4>
    </div>

    <!-- <div class="subscrirowprompt">
      <div class="subprocont" style="margin-left: 110px">
        <h6>特别提示：</h6>
        <div class="subprodition">
          <p>1、个人只提供电子发票。</p>
          <p>2、发票非实时开具，发票将在15个工作日内开具完成。</p>
          <p>3、如有其它问题，请咨询服务热线800-990-8900。</p>
        </div>
      </div>
    </div> -->
  </div>
</template>
        
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  props: ['totalBalance', 'totalPiece', 'totalDiscountV'],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      companyStyle: 'display: none',
      personalStyle: 'display: none',
      perandcomStyle: 'display: none',
      perandcomStyle_elec: 'display: none',
      invoiceCategory: '0',
      invoiceTypeMode: '',
      notes: '',
      nameShow: false,
      invoiceData: {
        //此处封装需要传到后端去的参数，定义好以后使用 v-model 双向关联
        invoiceType: '0',
        title: '',
        dutyparagraph: '',
        openBank: '',
        bankAccount: '',
        invoiceAddress: '',
        invoicePhone: '',
        mailedAddress: '',
        mailedPhone: '',
        mailedPostcode: '',
        mailedName: '',
        mailedType: '邮政挂号',
        invoiceReceiveEmail: '',
        invoiceReceiveBackEmail: '',
        invoiceReceivePhone: '',
        invoiceMode: '',
      },
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    invoiceCategory: function (value) {
      console.log()
      if (value != 0) {
        this.nameShow = true
      } else {
        this.nameShow = false
      }
      this.changeInvoice(value)
    },
    invoiceTypeMode: function (value) {
      let elements = Array.from(document.getElementsByClassName('prompt'))
      elements.forEach(function (item, inext) {
        item.style.display = 'none'
      })
      this.invoiceData.invoiceType = value.split('_')[0]
      this.invoiceData.invoiceMode = value.split('_')[1]
      if (value.startsWith('1')) {
        this.$refs['special1'].style.display = 'none'
        this.$refs['special2'].style.display = 'none'
        this.$refs['special3'].style.display = 'none'
        this.$refs['special4'].style.display = 'none'
      } else {
        this.$refs['special1'].style.display = 'inline'
        this.$refs['special2'].style.display = 'inline'
        this.$refs['special3'].style.display = 'inline'
        this.$refs['special4'].style.display = 'inline'
      }
      if (value.endsWith('0')) {
        this.perandcomStyle = 'display: none'
        this.perandcomStyle_elec = ''
      } else {
        this.perandcomStyle = ''
        this.perandcomStyle_elec = 'display: none'
      }
    },
  },
  //方法集合
  methods: {
    changeInvoice(invoice) {
      if (invoice == '0') {
        //不开发票
        this.companyStyle = 'display: none'
        this.personalStyle = 'display: none'
        this.perandcomStyle = 'display: none'
        this.perandcomStyle_elec = 'display: none'
      } else if (invoice == '3') {
        //个人
        this.companyStyle = 'display: none'
        this.personalStyle = ''
        this.perandcomStyle = 'display: none'
        this.perandcomStyle_elec = ''
        this.invoiceData.invoiceType = '3'
        this.invoiceData.invoiceMode = '0'
      } else if (invoice == '2') {
        //企业
        this.invoiceTypeMode = '1_0'
        this.companyStyle = ''
        this.personalStyle = 'display: none'
        this.perandcomStyle = 'display: none'
        this.perandcomStyle_elec = ''
      }
    },

    getInvoiceData(){
      console.log("==="+this.invoiceCategory)
      console.log("===invoiceData    "+JSON.stringify(this.invoiceData))
      this.invoiceData.invoiceType = this.invoiceCategory == '2' ? this.invoiceData.invoiceType : this.invoiceCategory
      return this.invoiceData
    },

    getInvoice() {
      this.$http.get('/cart/getUserInvoice.shtml').then((response) => {
        if (response.data.code == 0) {
          this.invoiceData = response.data.data

          this.invoiceData.mailedType = '邮政挂号'
        }
      })
    },
    //输入框获得焦点事件
    focusTips(name, tips) {
      this.$refs['msg' + name].style.display = 'inline'
      if (tips != '' && tips != undefined) {
        this.$refs['msg' + name].innerHTML = tips
      }
      this.$refs['msg' + name].style.color = 'rgb(191,166,80)'
    },
    submitValidate() {
      let flag = true
      let valElement = []
      if (this.invoiceCategory == '0') {
        //不开发票
        return true
      } else if (this.invoiceCategory == '3') {
        //个人发票
        valElement = ['invoiceReceiveEmail', 'invoiceReceivePhone', 'mailedName']
      } else {
        if (this.invoiceTypeMode == '1_0') {
          //企业普通发票(电子)
          valElement = ['invoiceReceiveEmail', 'invoiceReceiveBackEmail', 'invoiceReceivePhone', 'mailedName', 'title', 'dutyparagraph', 'openBank', 'bankAccount', 'invoiceAddress', 'invoicePhone']
        } else if (this.invoiceTypeMode == '1_1') {
          //企业普通发票(纸质)
          valElement = ['mailedAddress', 'mailedPhone', 'mailedPostcode', 'mailedName', 'title', 'dutyparagraph', 'openBank', 'bankAccount', 'invoiceAddress', 'invoicePhone']
        } else {
          //企业专用发票(纸质)
          valElement = ['mailedAddress', 'mailedPhone', 'mailedPostcode', 'mailedName', 'title', 'dutyparagraph', 'openBank', 'bankAccount', 'invoiceAddress', 'invoicePhone']
        }
      }

      for (let i = 0; i < valElement.length; i++) {
        flag = this.validateInput(valElement[i]) && flag
      }

      return flag
    },
    //输入框失去焦点事件，验证输入内容
    validateInput(name, tips) {
      if (this.invoiceCategory == '0') {
        //不开发票
        return true
      }
      if (this.invoiceData[name] == '' || this.invoiceData[name] == null) {
        let show = 'inline'
        //企业普通发票银行账号信息不提示必填
        if (((name == 'openBank' || name == 'bankAccount' || name == 'invoiceAddress' || name == 'invoicePhone') && this.invoiceData.invoiceType == '1') || name == 'invoiceReceiveBackEmail') {
          tips = ''
          show = 'none'
          this.$refs['msg' + name].style.display = show
          return true
        }
        if (tips != '' && tips != undefined) {
          this.$refs['msg' + name].innerHTML = tips
        }
        this.$refs['msg' + name].style.display = show
        this.$refs['msg' + name].style.color = 'red'
        return false
      } else {
        this.$refs['msg' + name].style.display = 'none'
        return this.validateInputFormat(name)
      }
    },
    //验证输入内容格式
    validateInputFormat(name) {
      this.$refs['msg' + name].style.color = 'red'
      if (name == 'title') {
        if (this.invoiceData.title.length > 100) {
          this.$refs['msg' + name].innerHTML = '发票抬头长度不大于100个字符!'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'dutyparagraph') {
        let dutyParagaphReg = /^[0-9a-zA-Z]*$/
        if (!dutyParagaphReg.test(this.invoiceData.dutyparagraph) || this.invoiceData.dutyparagraph == '' || this.invoiceData.dutyparagraph == null) {
          this.$refs['msg' + name].innerHTML = '请填写正确的纳税人识别号'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
        if (this.invoiceData.dutyparagraph.length > 20) {
          this.$refs['msg' + name].innerHTML = '纳税人识别号长度不大于20个字符！'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'openBank' /*&&this.invoiceData.invoiceType=='2'*/) {
        if (this.invoiceData.openBank.length > 100) {
          this.$refs['msg' + name].innerHTML = '开户行信息长度不大于100个字符!'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'bankAccount' /*&&this.invoiceData.invoiceType=='2'*/) {
        let isNUmberReg = /^[0-9]*$/
        if (this.invoiceData.bankAccount.length > 25 || !isNUmberReg.test(this.invoiceData.bankAccount)) {
          this.$refs['msg' + name].innerHTML = '请填写正确的开户行账号!'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'invoiceAddress' /*&&this.invoiceData.invoiceType=='2'*/) {
        if (this.invoiceData.invoiceAddress.length > 100) {
          this.$refs['msg' + name].innerHTML = '地址长度不大于100个字符!'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'invoicePhone' /*&&this.invoiceData.invoiceType=='2'*/) {
        let phoneReg = /^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/
        let cellPhoneReg = /^1\d{10}$/
        if (!phoneReg.test(this.invoiceData.invoicePhone) && !cellPhoneReg.test(this.invoiceData.invoicePhone)) {
          this.$refs['msg' + name].innerHTML = '请填写正确的电话信息！'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'mailedAddress') {
        if (this.invoiceData.mailedAddress.length > 100) {
          this.$refs['msg' + name].innerHTML = '地址长度不大于100个字符!'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'mailedPhone') {
        let phoneReg = /^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/
        let cellPhoneReg = /^1\d{10}$/
        if (!phoneReg.test(this.invoiceData.mailedPhone) && !cellPhoneReg.test(this.invoiceData.mailedPhone)) {
          this.$refs['msg' + name].innerHTML = '请填写正确的电话信息！'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'mailedPostcode') {
        let postCodeReg = /^\d{6}$/
        if (!postCodeReg.test(this.invoiceData.mailedPostcode)) {
          this.$refs['msg' + name].innerHTML = '请填写正确的邮政编码！'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'mailedName') {
        if (this.invoiceData.mailedName.length > 16) {
          this.$refs['msg' + name].innerHTML = '请填写联系人姓名，最多16位'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'invoiceReceiveEmail') {
        var emailReg = /(^[a-zA-Z0-9-_]|^[a-zA-Z0-9-_][\w-_\.]*[a-zA-Z0-9_-])@([\w\d-_]+\.)+\w+$/
        if (!emailReg.test(this.invoiceData.invoiceReceiveEmail)) {
          this.$refs['msg' + name].innerHTML = '请填写正确的发票接收邮箱！'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      if (name == 'invoiceReceiveBackEmail') {
        var emailReg = /(^[a-zA-Z0-9-_]|^[a-zA-Z0-9-_][\w-_\.]*[a-zA-Z0-9_-])@([\w\d-_]+\.)+\w+$/
        if (this.invoiceData.invoiceReceiveBackEmail != '') {
          if (!emailReg.test(this.invoiceData.invoiceReceiveBackEmail)) {
            this.$refs['msg' + name].innerHTML = '请填写正确的发票接收邮箱！'
            this.$refs['msg' + name].style.display = 'inline'
            return false
          }
        } else {
          return true
        }
      }
      if (name == 'invoiceReceivePhone') {
        let cellPhoneReg = /^1\d{10}$/
        if (!cellPhoneReg.test(this.invoiceData.invoiceReceivePhone)) {
          this.$refs['msg' + name].innerHTML = '请填写正确的发票接收手机！'
          this.$refs['msg' + name].style.display = 'inline'
          return false
        }
      }
      return true
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInvoice()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.prompt {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/cart/Bank.vue